(function ($) {


  const Init = (() => {

    let website = {},
      load = {},
      resize = {},
      resizeW = {},
      scroll = {},
      orientation = {},
      mod = {},
      anime = {},
      scrollOption = {},
      parallax = {},
      drawer = {},
      wp = {},
      slider = {},
      top = {},
      basic = {};

    website = {
      page: document.body.dataset.page,
      url: document.URL,
      winWidth: window.innerWidth,
      winHeight: window.innerHeight,
      scrollY: window.pageYOffset,
      scrollCurrent: 0,
      breakpoint: { pc: 1200, tb: 992, sp: 768, ss: 576 },
      ua: navigator.userAgent.toLowerCase(),
      isDesktop: true,
      isMobile: false,
      isFirst: true,
      animationFrame: null,

      headTag: document.getElementById('js-header'),
      footTag: document.getElementById('js-footer'),
      // headTag       : $('#js-header'),
      // footTag       : $('#js-footer'),

      act: 'is-act',
      inact: 'is-inact',
      actView: 'is-view',
      actOpen: 'is-open',
      actFixed: 'is-fixed',
      loaded: 'is-loaded',

      targetAnime: 'js-anime',
      actAnime: 'is-anime',
      shiftPoint: 0,
      shiftPc: 5,
      shiftSp: 10,
    };
    website.shiftPoint = website.breakpoint.tb;

    load = {
      functions: [],
      length: 0,
    };

    resize = {
      functions: [],
      length: 0,
      // fps      : 60,
      isRunning: false,
      animationFrame: null,
    };
    resizeW = {
      functions: [],
      length: 0,
      // fps      : 60,
      isRunning: false,
      animationFrame: null,
    };

    scroll = {
      functions: [],
      length: 0,
      // fps      : 60,
      isRunning: false,
      animationFrame: null,
    };

    orientation = {
      functions: [],
      length: 0,
      // fps      : 60,
      isRunning: false,
      animationFrame: null,
    };




    



    const WinLoad = {



    



      init() {



        window.addEventListener('load', function(e) {



          WinLoad.update();



        });



    



        console.log('!-- load init --!');



      },



    



      add(func) {



        load.functions.push(func);



        load.length = load.functions.length;



      },



    



      remove(func) {



        load.functions.splice(func, 1);



        load.length = load.functions.length;



      },



    



      update() {



        for ( let i = 0; i < load.length; i++ ) {



          let func = load.functions[i];



          func();



        }



      },



    



    }



    



    



    const WinResize = {



    



      init() {



        window.addEventListener('resize', function(e) {



          if ( !resize.isRunning ) {



            resize.isRunning = true;



    



            resize.animationFrame = window.requestAnimationFrame( WinResize.update );



    



            // if ( window.requestAnimationFrame ) {



            //   window.requestAnimationFrame(() => {



            //     WinResize.update();



            //   });



            // } else {



            //   setTimeout(() => {



            //     WinResize.update();



            //   }, 1000/resize.fps);



            // }



          }



        });



    



        console.log('!-- resize init --!');



      },



    



      add(func) {



        resize.functions.push(func);



        resize.length = resize.functions.length;



      },



    



      remove(func) {



        resize.functions.splice(func, 1);



        resize.length = resize.functions.length;



      },



    



      update() {



        website.winWidth  = window.innerWidth;



        website.winHeight = window.innerHeight;



        website.ua        = navigator.userAgent.toLowerCase();



    



        for ( let i = 0; i < resize.length; i++ ) {



          let func = resize.functions[i];



          func();



        }



    



        resize.isRunning = false;



      },



    



    }



    



    



    const WinResizeWidth = {



    



      init() {



        window.addEventListener('resize', function(e) {



          if ( website.winWidth != window.innerWidth && !resizeW.isRunning ) {



            resizeW.isRunning = true;



            resizeW.animationFrame = window.requestAnimationFrame( WinResizeWidth.update );



          }



        });



    



        console.log('!-- resizeW init --!');



      },



    



      add(func) {



        resizeW.functions.push(func);



        resizeW.length = resizeW.functions.length;



      },



    



      remove(func) {



        resizeW.functions.splice(func, 1);



        resizeW.length = resizeW.functions.length;



      },



    



      update() {



        for ( let i = 0; i < resizeW.length; i++ ) {



          let func = resizeW.functions[i];



          func();



        }



    



        resizeW.isRunning = false;



      },



    



    }



    



    



    const WinScroll = {



    



      init() {



        window.addEventListener('scroll', function(e) {



          if ( !scroll.isRunning ) {



            scroll.isRunning = true;



    



            scroll.animationFrame = window.requestAnimationFrame( WinScroll.update );



    



            // if ( window.requestAnimationFrame ) {



            //   window.requestAnimationFrame(() => {



            //     WinScroll.update();



            //   });



            // } else {



            //   setTimeout(() => {



            //     WinScroll.update();



            //   }, 1000/scroll.fps);



            // }



          }



        });



    



        console.log('!-- scroll init --!');



      },



    



      add(func) {



        scroll.functions.push(func);



        scroll.length = scroll.functions.length;



      },



    



      remove(func) {



        scroll.functions.splice(func, 1);



        scroll.length = scroll.functions.length;



      },



    



      update() {



        website.winHeight = window.innerHeight;



        website.scrollY   = window.pageYOffset;



    



        for ( let i = 0; i < scroll.length; i++ ) {



          let func = scroll.functions[i];



          func();



        }



    



        scroll.isRunning = false;



      },



    



    }



    



    



    const OrientationChange = {



    



      init() {



        window.addEventListener('orientationchange', function(e) {



          if ( !orientation.isRunning ) {



            orientation.isRunning = true;



    



            orientation.animationFrame = window.requestAnimationFrame( OrientationChange.update );



          }



        });



    



        console.log('!-- orientationchange init --!');



      },



    



      add(func) {



        orientation.functions.push(func);



        orientation.length = orientation.functions.length;



      },



    



      remove(func) {



        orientation.functions.splice(func, 1);



        orientation.length = orientation.functions.length;



      },



    



      update() {



        for ( let i = 0; i < orientation.length; i++ ) {



          let func = orientation.functions[i];



          func();



        }



    



        orientation.isRunning = false;



      },



    



    }



    

    
    const Modules = {
    
      init() {
        mod = {
          targetSmooth: 'js-scroll',
          smoothSpeed: 600,
    
          targetTab: 'js-tab',
    
          targetTermSelect: 'js-termSelect',
    
          targetAccordion: 'js-accordion',
          targetAccordionSP: 'js-accordionSP',
    
          postalSearchId: 'js-postalSearch',
          targetFile: 'js-file',
          targetFileName: 'js-fileName',
          targetFileDelete: 'mwform-file-delete',
          targetFormDisplay: 'js-formDisplay',
    
          // targetModalOpen   : 'js-modal',
          // targetModalClose  : 'js-modalClose',
          // targetModalOverlay: 'js-modalOverlay',
          // actBodyModal      : 'is-modal',
    
          // targetTmpClone: 'js-tmpClone',
    
          // targetLozad: '.js-lozad',
    
          // targetCursor: 'js-cursor',
          // targetCursorTag: '',
          // cursorMagnet: false,
          // cursorClass: website.act,
          // cursorOffClass: website.inact,
    
          // targetAlign     : 'js-align',
          // targetAlignList : [],
          // alignAddClass   : 'u-alignHeight',
    
          // masonryElms: document.getElementsByClassName('js-masonry'),
        };
    
        // if (document.getElementById(mod.targetCursor) != null) {
        //   mod.targetCursorTag = document.getElementById(mod.targetCursor);
        //   this.cursor();
        // }
    
        // let alignList = document.querySelectorAll('.' + mod.targetAlign);
        // mod.targetAlignList = Array.prototype.slice.call(alignList, 0);
    
        this.viewportHeight();
        this.scrollbarWidth();
        this.iosCheck();
        this.deviceCheck();
        this.smoothScroll();
        this.tabBtn();
        this.termSelect();
        this.accordionBtn();
        this.postalSearch();
        this.inputFile();
        this.formDisplay();
        // this.modalBtn();
        // this.tmpClone();
        // this.masonry();
      },
    
      viewportHeight() {
        let vh = website.winHeight * 0.01;
        document.documentElement.style.setProperty('--vh', `${vh}px`);
      },
      scrollbarWidth() {
        let element = document.createElement('div');
        element.style.visibility = 'hidden';
        element.style.overflow = 'scroll';
        document.body.appendChild(element);
        let scrollbarWidth = element.offsetWidth - element.clientWidth;
        document.body.removeChild(element);
        document.documentElement.style.setProperty('--scrollbar', `${scrollbarWidth}px`);
      },
    
      iosCheck() {
        if (website.ua.indexOf('ipad') > -1 || website.ua.indexOf('iphone') > -1 || (website.ua.indexOf('macintosh') > -1 && 'ontouchend' in document)) {
          $('body').addClass('is-ios');
        } else {
          $('body').removeClass('is-ios');
        }
      },
    
      deviceCheck() {
        if (
          website.ua.indexOf('iphone') > -1 ||
          website.ua.indexOf('ipod') > -1 ||
          website.ua.indexOf('android') > -1 && website.ua.indexOf('mobile') > -1
        ) {
          website.isDesktop = false;
          website.isMobile = true;
          $('body').removeClass('is-pc is-tb').addClass('is-sp');
        } else if (
          website.ua.indexOf('ipad') > -1 ||
          website.ua.indexOf('Android') > -1 ||
          (website.ua.indexOf('macintosh') > -1 && 'ontouchend' in document)
        ) {
          website.isDesktop = false;
          website.isMobile = false;
          $('body').removeClass('is-pc is-sp').addClass('is-tb');
        } else {
          website.isDesktop = true;
          website.isMobile = false;
          $('body').removeClass('is-tb is-sp').addClass('is-pc');
        }
      },
    
      smoothScroll() {
        $(document).on('click', '.' + mod.targetSmooth + '[href^="#"]', function () {
          let href = $(this).attr("href");
          let target = $((href == "#") ? 'html' : href);
    
          if (target.length) {
            let shift = website.headTag.offsetHeight;
            let position = target.offset().top - shift;
    
            $('body,html').animate({ scrollTop: position }, mod.smoothSpeed, 'swing');
            return false;
          }
        });
      },
    
      tabBtn() {
        $('.' + mod.targetTab).each(function () {
          let tabObj = $('> li > a', this),
            contId = ($(this).data('tab')) ? $(this).data('tab') : '',
            contObj = (contId) ? $(contId).children('div') : $(this).next().children('div');
    
          tabObj.on('click', function () {
            let tabHref = $(this).attr('href');
    
            tabObj.removeClass(website.act);
            $(this).addClass(website.act);
    
            contObj.hide();
            $(tabHref).fadeIn();
    
            return false;
          });
        });
      },
    
      termSelect() {
        $('.' + mod.targetTermSelect).each(function () {
          const wrapElm = $(this);
          const clickElm = $('> label input', this);
    
          clickElm.on('change', function (e) {
            const termAllElm = wrapElm.find('input:not([name])')[0];
            const chekedElmsNum = wrapElm.find('input:checked').length;
    
            if ($(this).val() === 'all') {
              clickElm.prop('checked', false);
              termAllElm.checked = true;
            } else if (chekedElmsNum === 0) {
              termAllElm.checked = true;
            } else if (chekedElmsNum >= 2) {
              termAllElm.checked = false;
            }
          });
        });
      },
    
      accordionBtn() {
        $('.' + mod.targetAccordion).on('click', function () {
          if ($(this).hasClass(website.act)) {
            $(this).removeClass(website.act).next().stop().slideUp('fast');
            // $(this).removeClass(website.act);
          } else {
            $(this).addClass(website.act).next().stop().slideDown();
            // $(this).addClass(website.act);
          }
        });
    
        $('.' + mod.targetAccordionSP).each(function () {
          $(this).next().hide();
        });
        $('.' + mod.targetAccordionSP).on('click', function () {
          if (website.winWidth < website.breakpoint.sp) {
            if ($(this).hasClass(website.act)) {
              $(this).removeClass(website.act).next().stop().slideUp('fast');
              // $(this).removeClass(website.act);
            } else {
              $(this).addClass(website.act).next().stop().slideDown();
              // $(this).addClass(website.act);
            }
            return false;
          }
        });
      },
    
      postalSearch() {
        //該当フォーム
        let hadr = document.querySelector(".h-adr"),
          postalcode = document.querySelectorAll(".p-postal-code"),
          btn = document.querySelector("#" + mod.postalSearchId),
          cancelFlag = true;
    
        if (hadr !== null && postalcode.length !== 0 && btn !== null) {
          //イベントをキャンセルするリスナ
          let onKeyupCanceller = function (e) {
            if (cancelFlag) {
              e.stopImmediatePropagation();
            }
            return false;
          };
    
          // 郵便番号の入力欄
          let postalField = postalcode[postalcode.length - 1];
    
          //通常の挙動をキャンセルできるようにイベントを追加
          postalField.addEventListener("keyup", onKeyupCanceller, false);
    
          //ボタンクリック時
          btn.addEventListener("click", function (e) {
            //キャンセルを解除
            cancelFlag = false;
    
            //発火
            let event;
            if (typeof Event === "function") {
              event = new Event("keyup");
            } else {
              event = document.createEvent("Event");
              event.initEvent("keyup", true, true);
            }
            postalField.dispatchEvent(event);
    
            //キャンセルを戻す
            cancelFlag = true;
          });
        }
      },
      inputFile() {
        $(document).on('change', '.' + mod.targetFile + ' input', function () {
          let file = $(this).prop('files')[0];
          $('.' + mod.targetFileName).text(file.name);
        });
        $(document).on('click', '.' + mod.targetFileDelete, function () {
          $('.' + mod.targetFileName).text('選択されておりません');
        });
      },
      formDisplay() {
        const displayElms = document.querySelectorAll('.' + mod.targetFormDisplay);
        displayElms.forEach((displayElm) => {
          const inputName = displayElm.dataset.formDisplay;
          const inputNameElms = document.querySelectorAll('[name="' + inputName + '"]');
    
          inputNameElms.forEach(function (inputNameElm) {
            Modules.formDisplayInput(inputNameElm);
    
            inputNameElm.addEventListener("change", () => {
              const displayGroup = document.querySelectorAll('[data-form-display-group="' + inputName + '"]');
              displayGroup.forEach((groupElm) => {
                groupElm.style.display = 'none';
    
                const elms = groupElm.querySelectorAll('input');
                elms.forEach((elm) => {
                  if (elm.type === 'radio' || elm.type === 'checkbox') {
                    elm.checked = false;
                  } else if (elm.type === 'text') {
                    elm.value = '';
                  }
                });
              });
    
              Modules.formDisplayInput(inputNameElm);
            });
          });
        });
      },
      formDisplayInput(inputNameElm) {
        if (inputNameElm.type === 'hidden' || (inputNameElm.type !== 'hidden' && inputNameElm.checked)) {
          const displayTarget = document.querySelector('[data-form-display-select="' + inputNameElm.value + '"]');
          if (displayTarget != null) {
            displayTarget.style.display = 'block';
          }
        }
      },
    
      modalBtn() {
        $(document).on('click', '.' + mod.targetModalOpen, function (e) {
          let href = $(this).attr("href");
          $('html').addClass(mod.actBodyModal);
          $(href).addClass(website.actOpen).parent().addClass(website.act);
          return false;
        });
    
        $('.' + mod.targetModalClose).each(function () {
          $(this).on('click', function () {
            // $('.' + website.actOpen + ' iframe').each(function () {
            //   let playerWindow = $(this)[0].contentWindow;
            //   playerWindow.postMessage('{"event":"command", "func":"pauseVideo", "args":""}', "*");
            // });
    
            $('html').removeClass(mod.actBodyModal);
            $(this).closest('.' + website.actOpen).removeClass(website.actOpen).parent().removeClass(website.act);
          });
        });
    
        $(document).on('click', '.' + mod.targetModalOverlay, function () {
          // $('.' + website.actOpen + ' iframe').each(function () {
          //   let playerWindow = $(this)[0].contentWindow;
          //   playerWindow.postMessage('{"event":"command", "func":"pauseVideo", "args":""}', "*");
          // });
    
          $('html').removeClass(mod.actBodyModal);
          $(this).nextAll('.' + website.actOpen).removeClass(website.actOpen).parent().removeClass(website.act);
        });
      },
    
      // tmpClone() {
      //   $('.' + mod.targetTmpClone).each(function () {
      //     let targetId = $(this).data('tmp'),
      //       loopNum = $(this).data('loop');
    
      //     for (var i = 0; i < loopNum; i++) {
      //       let clone = document.getElementById(targetId).content.cloneNode(true);
      //       this.appendChild(clone);
      //     }
      //   });
      // },
    
      // lozad() {
      //   const el = document.querySelectorAll(mod.targetLozad);
      //   const observer = lozad(el);
      //   observer.observe();
      // },
    
      // cursor() {
      //   document.addEventListener('mousemove', function (e) {
      //     if (!mod.cursorMagnet) {
      //       mod.targetCursorTag.style.transform = 'translate(' + e.clientX + 'px, ' + e.clientY + 'px)';
      //     }
      //   });
    
    
      //   let linkElem = document.querySelectorAll('a, button, [data-cursor]');
      //   for (let i = 0; i < linkElem.length; i++) {
      //     linkElem[i].addEventListener('mouseover', function (e) {
      //       if (this.dataset.hover !== undefined) {
      //         mod.cursorClass = this.dataset.hover;
      //       } else {
      //         mod.cursorClass = website.act;
      //       }
      //       mod.targetCursorTag.classList.add(mod.cursorClass);
    
      //       if (this.dataset.magnet !== undefined) {
      //         mod.cursorMagnet = this.querySelector('.' + this.dataset.magnet);
      //       }
    
      //     });
      //     linkElem[i].addEventListener('mouseout', function (e) {
      //       mod.targetCursorTag.classList.remove(mod.cursorClass);
      //       mod.cursorMagnet = false;
      //     });
      //   }
    
      //   let linkOffElem = document.querySelectorAll('[data-cursor-off]');
      //   for (let i = 0; i < linkOffElem.length; i++) {
      //     linkOffElem[i].addEventListener('mouseover', function (e) {
      //       document.body.classList.add(mod.cursorOffClass);
      //     });
      //     linkOffElem[i].addEventListener('mouseout', function (e) {
      //       document.body.classList.remove(mod.cursorOffClass);
      //     });
      //   }
      // },
      // cursorMagnet() {
      //   let cursorMagnetClient = mod.cursorMagnet.getBoundingClientRect();
      //   mod.targetCursorTag.style.transform = 'translate(' + (cursorMagnetClient.left + cursorMagnetClient.width / 2) + 'px, ' + (cursorMagnetClient.top + cursorMagnetClient.height / 2) + 'px)';
      // },
    
      // alignHeight() {
      //   let alignHeight  = 0;
    
      //   mod.targetAlignList.forEach((target) => {
      //     target.style.minHeight = 'auto';
      //     target.classList.add(mod.alignAddClass);
      //     alignHeight = ( target.offsetHeight > alignHeight ) ? target.offsetHeight: alignHeight;
      //     target.classList.remove(mod.alignAddClass);
      //   });
      //   mod.targetAlignList.forEach((target) => {
      //     target.style.minHeight = alignHeight + 'px';
      //   });
      // },
    
      masonry() {
        if (mod.masonryElms != null) {
          for (let i = 0; i < mod.masonryElms.length; i++) {
            const masonry = mod.masonryElms[0];
            const childElms = masonry.children;
            const rowHeight = parseInt(window.getComputedStyle(masonry).getPropertyValue('grid-auto-rows'));
    
            for (let i = 0; i < childElms.length; i++) {
              const rowSpan = Math.ceil(childElms[i].querySelector("*").clientHeight / rowHeight);
              childElms[i].style.gridRowEnd = 'span ' + rowSpan;
            }
          }
        }
      },
    
    }
    

    
    const DrawerMenu = {
    
      init() {
        drawer = {
          duration: 10,
    
          menu: 'js-drawerMenu',
          menuPanel: 'js-drawerMenuPanel',
          menuToggle: '#js-drawerMenuToggle',
          menuClose: '#js-drawerMenuPanel, #js-drawerMenu .js-scroll',
          menuAct: 'is-menuOpen',
    
          search: 'js-drawerSearch',
          searchPanel: 'js-drawerSearchPanel',
          searchToggle: '#js-drawerSearchToggle',
          searchClose: '#js-drawerSearchPanel, #js-drawerSearch .js-scroll',
          searchAct: 'is-searchOpen',
        };
    
        this.menu();
        this.search();
      },
    
      menu() {
        if (document.getElementById(drawer.menu) != null) {
          let slideoutInst = new Slideout({
            'panel': document.getElementById(drawer.menuPanel),
            'menu': document.getElementById(drawer.menu),
            'duration': drawer.duration,
            'openclass': drawer.menuAct,
          });
    
          let nodeList = document.querySelectorAll(drawer.menuToggle);
          let node = Array.prototype.slice.call(nodeList, 0);
          node.forEach(function (elem, index) {
            elem.addEventListener('click', function () {
              slideoutInst.toggle();
            });
          });
    
          let nodeListClose = document.querySelectorAll(drawer.menuClose);
          let nodeClose = Array.prototype.slice.call(nodeListClose, 0);
          nodeClose.forEach(function (elem, index) {
            elem.addEventListener('click', function () {
              slideoutInst.close();
            });
          });
        }
      },
    
      search() {
        if (document.getElementById(drawer.search) != null) {
          let slideoutInst = new Slideout({
            'panel': document.getElementById(drawer.searchPanel),
            'menu': document.getElementById(drawer.search),
            'duration': drawer.duration,
            'openclass': drawer.searchAct,
          });
    
          let nodeList = document.querySelectorAll(drawer.searchToggle);
          let node = Array.prototype.slice.call(nodeList, 0);
          node.forEach(function (elem, index) {
            elem.addEventListener('click', function () {
              slideoutInst.toggle();
            });
          });
    
          let nodeListClose = document.querySelectorAll(drawer.searchClose);
          let nodeClose = Array.prototype.slice.call(nodeListClose, 0);
          nodeClose.forEach(function (elem, index) {
            elem.addEventListener('click', function () {
              slideoutInst.close();
            });
          });
        }
      },
    
    }
    
    

    
    const Wordpress = {
    
      init() {
        wp = {
          editorTarget: 'js-editor',
          tableClass: 'c-tblResponsive',
          iframeclass: 'c-iframe',
        };
    
        this.wpEditor();
      },
    
      wpEditor() {
        if (document.getElementById(wp.editorTarget) != null) {
          $('#' + wp.editorTarget + ' table').each(function () {
            $(this).wrap('<div class="' + wp.tableClass + '"></div>');
          });
          $('#' + wp.editorTarget + ' iframe').each(function () {
            $(this).wrap('<div class="' + wp.iframeclass + '"></div>');
          });
        }
        // if ( $('.' + wp.editorTarget).length ) {
        //   $( '.' + wp.editorTarget + ' table' ).each(function() {
        //     $(this).wrap('<div class="' + wp.tableClass + '"></div>');
        //   });
        //   $( '.' + wp.editorTarget + ' iframe' ).each(function() {
        //     $(this).wrap('<div class="' + wp.iframeclass + '"></div>');
        //   });
        // }
      }
    
    }
    
    

    
    const SplideSlider = {
    
      init() {
        slider = {
          homeKvElm: document.getElementById('js-splideHomeKv'),
          optionsKv: {
            type: 'fade',
            rewind: true,
            autoplay: true,
            speed: 1000,
            pagination: false,
            arrows: false,
            interval: 4000,
            reducedMotion: {
              speed: 1000,
              rewindSpeed: 1000,
              autoplay: true,
            },
          },
          optionsKvSvg: {
            maskId: '#js-maskKv',
            path: [
              "m9.69,281.51c-4.3-27.73,12.59-60.96,37.52-73.85L415.05,17.57c24.93-12.88,67.7-18.27,95.05-11.98l482.99,111.17c27.35,6.29,48.01,34.34,45.92,62.33l-22.39,299.47c-2.09,27.98-25.72,57.72-52.51,66.08l-512.08,159.77c-26.79,8.36-70.23,7.18-96.52-2.61l-250.07-93.12c-26.3-9.79-51.33-40.49-55.63-68.23L9.69,281.51Z",
              "m89.42,271.05c5.38-27.54,30.7-59.54,56.27-71.11L526.07,27.82c25.57-11.57,66.94-10.6,91.93,2.15l303.65,154.93c25,12.75,48.69,45.92,52.64,73.7l35.62,250.2c3.95,27.78-14.7,57.44-41.46,65.89l-350.06,110.65c-26.76,8.46-71.07,10.4-98.46,4.33l-441.21-97.86c-27.4-6.08-45.41-33.58-40.03-61.12l50.74-259.64Z",
              "m62.04,310.94c.03-28.06,21.76-58.48,48.31-67.58L667.18,52.28c26.54-9.11,67.42-3.91,90.84,11.56l189.39,125.08c23.42,15.46,40.87,51.01,38.77,79l-22.39,299.47c-2.09,27.98-26.28,55.55-53.76,61.26l-147.45,30.64c-27.48,5.71-72.74,7.58-100.6,4.16l-549.56-67.52c-27.85-3.42-50.62-29.18-50.6-57.24l.21-227.74Z"
            ],
          },
    
    
          homePickupElm: document.getElementById('js-splideHomePickup'),
          optionsPickup: {
            type: 'loop',
            autoplay: false,
            pagination: false,
            arrows: false,
            pauseOnHover: false,
            pauseOnFocus: false,
            destroy: true,
            reducedMotion: {
              speed: 400,
              rewindSpeed: 400,
              autoplay: false,
            },
            breakpoints: {
              // 991.9: {
              //   destroy: false,
              //   perPage: 2,
              //   gap: '4rem',
              //   pagination: true,
              // },
              767.9: {
                destroy: false,
                pagination: true,
                arrows: true,
                perPage: 2,
                gap: '4rem',
              },
              575.9: {
                destroy: false,
                pagination: true,
                arrows: true,
                perPage: 1,
                gap: '4rem',
              },
            },
          },
    
    
          homeBusinessElm: document.getElementById('js-splideHomeBusiness'),
          homeBusinessNumCurrentElm: document.getElementById('js-splideHomeBusinessNumCurrent'),
          homeBusinessNumAllElm: document.getElementById('js-splideHomeBusinessNumAll'),
          optionsBusiness: {
            type: 'loop',
            speed: 800,
            autoplay: 'pause',
            interval: 5000,
            perPage: 3,
            perMove: 1,
            focus: 'center',
            updateOnMove: true,
            gap: '11rem',
            pagination: true,
            arrows: true,
            pauseOnHover: false,
            pauseOnFocus: false,
            reducedMotion: {
              speed: 800,
              rewindSpeed: 800,
              autoplay: 'pause',
            },
            breakpoints: {
              991.9: {
                perPage: 1,
                padding: '25vw',
              },
              767.9: {
                perPage: 1,
                padding: '18vw',
                gap: '9rem',
              },
              575.9: {
                perPage: 1,
                padding: '11vw',
                gap: '6rem',
              },
            },
          },
    
    
          businessElms: document.getElementsByClassName('js-splideBusiness'),
          splideBusinessArr: [],
          optionsBusinessSub: {
            type: 'fade',
            rewind: true,
            speed: 700,
            rewindSpeed: 700,
            arrows: false,
            pagination: true,
            waitForTransition: false,
            updateOnMove: true,
            pauseOnHover: false,
            pauseOnFocus: false,
            reducedMotion: {
              speed: 700,
              rewindSpeed: 700,
              autoplay: false,
            }
          },
    
    
          productsMainElm: document.getElementById('js-splideProductsMain'),
          optionsProductsMain: {
            type: 'loop',
            gap: '1rem',
            rewind: true,
            speed: 700,
            rewindSpeed: 700,
            arrows: false,
            pagination: false,
            waitForTransition: false,
            updateOnMove: true,
            pauseOnHover: false,
            pauseOnFocus: false,
            reducedMotion: {
              speed: 700,
              rewindSpeed: 700,
              autoplay: false,
            }
          },
          productsThumbElm: document.getElementById('js-splideProductsThumb'),
          optionsProductsThumb: {
            perPage: 8,
            isNavigation: true,
            rewind: true,
            speed: 700,
            rewindSpeed: 700,
            arrows: false,
            pagination: false,
            waitForTransition: false,
            updateOnMove: true,
            pauseOnHover: false,
            pauseOnFocus: false,
            reducedMotion: {
              speed: 700,
              rewindSpeed: 700,
              autoplay: false,
            }
          },
    
    
          productsVideoElm: document.getElementById('js-splideProductsVideo'),
          productsVideoNumCurrentElm: document.getElementById('js-splideProductsVideoNumCurrent'),
          productsVideoNumAllElm: document.getElementById('js-splideProductsVideoNumAll'),
          optionsProductsVideo: {
            // type: 'loop',
            rewind: true,
            focus: 0,
            trimSpace: false,
            speed: 800,
            autoplay: 'pause',
            interval: 5000,
            perPage: 2,
            perMove: 1,
            updateOnMove: true,
            gap: '8rem',
            pagination: true,
            arrows: true,
            pauseOnHover: false,
            pauseOnFocus: false,
            reducedMotion: {
              speed: 800,
              rewindSpeed: 800,
              autoplay: 'pause',
            },
            breakpoints: {
              991.9: {
                perPage: 2,
                gap: '4rem',
              },
              767.9: {
                perPage: 1,
                gap: '10vw',
              },
            },
          },
    
    
          productsVoiceElm: document.getElementById('js-splideProductsVoice'),
          productsVoiceNumCurrentElm: document.getElementById('js-splideProductsVoiceNumCurrent'),
          productsVoiceNumAllElm: document.getElementById('js-splideProductsVoiceNumAll'),
          optionsProductsVoice: {
            // type: 'loop',
            rewind: true,
            focus: 0,
            trimSpace: false,
            speed: 800,
            autoplay: 'pause',
            interval: 5000,
            perPage: 2,
            perMove: 1,
            updateOnMove: true,
            gap: '8rem',
            pagination: true,
            arrows: true,
            pauseOnHover: false,
            pauseOnFocus: false,
            reducedMotion: {
              speed: 800,
              rewindSpeed: 800,
              autoplay: 'pause',
            },
            breakpoints: {
              991.9: {
                perPage: 2,
                gap: '4rem',
              },
              767.9: {
                perPage: 1,
                gap: '10vw',
              },
            },
          },
    
    
          productsSuperviseElm: document.getElementById('js-splideProductsSupervise'),
          productsSuperviseNumCurrentElm: document.getElementById('js-splideProductsSuperviseNumCurrent'),
          productsSuperviseNumAllElm: document.getElementById('js-splideProductsSuperviseNumAll'),
          optionsProductsSupervise: {
            // type: 'loop',
            rewind: true,
            focus: 0,
            trimSpace: false,
            speed: 800,
            autoplay: 'pause',
            interval: 5000,
            perPage: 2,
            perMove: 1,
            updateOnMove: true,
            gap: '12rem',
            pagination: true,
            arrows: true,
            pauseOnHover: false,
            pauseOnFocus: false,
            reducedMotion: {
              speed: 800,
              rewindSpeed: 800,
              autoplay: 'pause',
            },
            breakpoints: {
              991.9: {
                perPage: 2,
                gap: '5rem',
              },
              767.9: {
                perPage: 1,
                gap: '10vw',
              },
            },
          },
    
    
          newsNewElm: document.getElementById('js-splideNewsNew'),
          optionsNewsNew: {
            // type: 'loop',
            autoplay: 'pause',
            pagination: false,
            arrows: false,
            pauseOnHover: false,
            pauseOnFocus: false,
            destroy: true,
            reducedMotion: {
              speed: 400,
              rewindSpeed: 400,
              autoplay: 'pause',
            },
            breakpoints: {
              991.9: {
                destroy: false,
                perPage: 2,
                perMove: 2,
                gap: '2rem',
                pagination: true,
              },
              767.9: {
                destroy: false,
                perPage: 1,
                perMove: 1,
                gap: '2rem',
                pagination: true,
              },
            },
          },
    
    
          productsNewElm: document.getElementById('js-splideProductsNew'),
          optionsProductsNew: {
            // type: 'loop',
            autoplay: 'pause',
            pagination: false,
            arrows: false,
            pauseOnHover: false,
            pauseOnFocus: false,
            destroy: true,
            reducedMotion: {
              speed: 400,
              rewindSpeed: 400,
              autoplay: 'pause',
            },
            breakpoints: {
              991.9: {
                destroy: false,
                perPage: 2,
                perMove: 2,
                gap: '2rem',
                pagination: true,
              },
              767.9: {
                destroy: false,
                perPage: 1,
                perMove: 1,
                gap: '2rem',
                pagination: true,
              },
            },
          },
    
    
          productsExpertElm: document.getElementById('js-splideProductsExpert'),
          optionsProductsExpert: {
            // type: 'loop',
            gap: '3rem',
            autoplay: 'pause',
            pagination: true,
            arrows: false,
            pauseOnHover: false,
            pauseOnFocus: false,
            destroy: true,
            reducedMotion: {
              speed: 400,
              rewindSpeed: 400,
              autoplay: 'pause',
            },
            breakpoints: {
              991.9: {
                destroy: false,
                perPage: 3,
                perMove: 3,
              },
              767.9: {
                destroy: false,
                perPage: 2,
                perMove: 2,
              },
              575.9: {
                destroy: false,
                perPage: 1,
                perMove: 1,
              },
            },
          },
    
    
          lpLoopElm: document.getElementById('js-splideLpLoop'),
          optionsLpLoop: {
            autoScroll: {
              speed: 0.5,
              pauseOnHover: false,
              pauseOnFocus: false,
            },
            type: 'loop',
            start: 1,
            // perPage: 5,
            fixedWidth: '16rem',
            gap: '4rem',
            pagination: false,
            arrows: false,
          },
    
          lpLoopMeritElm: document.getElementById('js-splideLpLoopMerit'),
          optionsLpLoopMerit: {
            autoScroll: {
              speed: 0.5,
              pauseOnHover: false,
              pauseOnFocus: false,
            },
            type: 'loop',
            start: 1,
            // perPage: 5,
            fixedWidth: '28rem',
            gap: '7rem',
            pagination: false,
            arrows: false,
            breakpoints: {
              991.9: {
                fixedWidth: '22rem',
                gap: '5.5rem',
              },
              767.9: {
                fixedWidth: '16rem',
                gap: '4rem',
              },
            },
          },
    
    
          lpMeritElm: document.getElementsByClassName('js-splideLpMerit'),
          optionsLpMerit: {
            type: 'loop',
            autoplay: false,
            pagination: true,
            arrows: true,
            pauseOnHover: false,
            pauseOnFocus: false,
            reducedMotion: {
              speed: 400,
              rewindSpeed: 400,
              autoplay: false,
            },
          },
    
    
          commonBnrElm: document.getElementById('js-splideBnr'),
          optionsBnr: {
            // type: 'loop',
            autoplay: 'pause',
            pagination: false,
            arrows: false,
            pauseOnHover: false,
            pauseOnFocus: false,
            destroy: true,
            reducedMotion: {
              speed: 400,
              rewindSpeed: 400,
              autoplay: 'pause',
            },
            breakpoints: {
              767.9: {
                destroy: false,
                gap: '2rem',
                pagination: true,
              },
            },
          },
        };
      },
    
      top() {
        if (slider.homeKvElm != null) {
          const splideKv = new Splide(slider.homeKvElm, slider.optionsKv);
    
          $(slider.optionsKvSvg.maskId).attr('d', slider.optionsKvSvg.path[0]);
    
          splideKv.on('move', function (newIndex) {
            Snap(slider.optionsKvSvg.maskId).animate({ d: slider.optionsKvSvg.path[newIndex] }, slider.optionsKv.speed, mina.easeout);
          });
    
          splideKv.mount();
        }
    
        if (slider.homePickupElm != null) {
          const splidePickup = new Splide(slider.homePickupElm, slider.optionsPickup);
          splidePickup.mount();
        }
    
        if (slider.homeBusinessElm != null) {
          const splideBusiness = new Splide(slider.homeBusinessElm, slider.optionsBusiness);
    
          splideBusiness.on('mounted', () => {
            const slideLength = splideBusiness.Components.Elements.slides.length;
            slider.homeBusinessNumAllElm.innerHTML = slideLength.toString().padStart(2, '0');
    
            splideBusiness.Components.Pagination.items.forEach((elm, i) => {
              elm.button.style.animationDuration = slider.optionsBusiness.interval + 'ms';
              elm.button.classList.remove('is-active');
            });
          });
          splideBusiness.on('ready', () => {
            splideBusiness.Components.Autoplay.play();
            splideBusiness.Components.Pagination.items[0].button.classList.add('is-active');
          });
          splideBusiness.on('move', (newidx, previdx, dest) => {
            splideBusiness.Components.Autoplay.pause();
            splideBusiness.Components.Autoplay.play();
    
            const slideIndex = newidx + 1;
            slider.homeBusinessNumCurrentElm.innerHTML = slideIndex.toString().padStart(2, '0');
          });
    
          splideBusiness.mount();
        }
    
      },
    
      other() {
        const slideBusinessNum = slider.businessElms.length;
        for (let i = 0; i < slideBusinessNum; i++) {
          slider.splideBusinessArr[i] = new Splide(slider.businessElms[i], slider.optionsBusinessSub);
          slider.splideBusinessArr[i].mount();
        }
    
        if (slider.productsMainElm != null && slider.productsThumbElm != null) {
          const splideProductsMain = new Splide(slider.productsMainElm, slider.optionsProductsMain);
          const splideProductsThumb = new Splide(slider.productsThumbElm, slider.optionsProductsThumb);
          splideProductsMain.sync(splideProductsThumb);
          splideProductsMain.mount();
          splideProductsThumb.mount();
        }
    
        if (slider.productsVideoElm != null) {
          const splideProductsVideo = new Splide(slider.productsVideoElm, slider.optionsProductsVideo);
    
          splideProductsVideo.on('mounted', () => {
            const slideLength = splideProductsVideo.Components.Elements.slides.length;
            slider.productsVideoNumAllElm.innerHTML = slideLength.toString().padStart(2, '0');
    
            splideProductsVideo.Components.Pagination.items.forEach((elm, i) => {
              elm.button.style.animationDuration = slider.optionsProductsVideo.interval + 'ms';
              elm.button.classList.remove('is-active');
            });
          });
          splideProductsVideo.on('ready', () => {
            splideProductsVideo.Components.Autoplay.play();
            splideProductsVideo.Components.Pagination.items[0].button.classList.add('is-active');
          });
          splideProductsVideo.on('move', (newidx, previdx, dest) => {
            splideProductsVideo.Components.Autoplay.pause();
            splideProductsVideo.Components.Autoplay.play();
    
            const slideIndex = newidx + 1;
            slider.productsVideoNumCurrentElm.innerHTML = slideIndex.toString().padStart(2, '0');
          });
    
          splideProductsVideo.mount();
        }
    
        if (slider.productsVoiceElm != null) {
          const splideProductsVoice = new Splide(slider.productsVoiceElm, slider.optionsProductsVoice);
    
          splideProductsVoice.on('mounted', () => {
            const slideLength = splideProductsVoice.Components.Elements.slides.length;
            slider.productsVoiceNumAllElm.innerHTML = slideLength.toString().padStart(2, '0');
    
            splideProductsVoice.Components.Pagination.items.forEach((elm, i) => {
              elm.button.style.animationDuration = slider.optionsProductsVoice.interval + 'ms';
              elm.button.classList.remove('is-active');
            });
          });
          splideProductsVoice.on('ready', () => {
            splideProductsVoice.Components.Autoplay.play();
            splideProductsVoice.Components.Pagination.items[0].button.classList.add('is-active');
          });
          splideProductsVoice.on('move', (newidx, previdx, dest) => {
            splideProductsVoice.Components.Autoplay.pause();
            splideProductsVoice.Components.Autoplay.play();
    
            const slideIndex = newidx + 1;
            slider.productsVoiceNumCurrentElm.innerHTML = slideIndex.toString().padStart(2, '0');
          });
    
          splideProductsVoice.mount();
        }
    
        if (slider.productsSuperviseElm != null) {
          const splideProductsSupervise = new Splide(slider.productsSuperviseElm, slider.optionsProductsSupervise);
    
          splideProductsSupervise.on('mounted', () => {
            const slideLength = splideProductsSupervise.Components.Elements.slides.length;
            slider.productsSuperviseNumAllElm.innerHTML = slideLength.toString().padStart(2, '0');
    
            splideProductsSupervise.Components.Pagination.items.forEach((elm, i) => {
              elm.button.style.animationDuration = slider.optionsProductsSupervise.interval + 'ms';
              elm.button.classList.remove('is-active');
            });
          });
          splideProductsSupervise.on('ready', () => {
            splideProductsSupervise.Components.Autoplay.play();
            splideProductsSupervise.Components.Pagination.items[0].button.classList.add('is-active');
          });
          splideProductsSupervise.on('move', (newidx, previdx, dest) => {
            splideProductsSupervise.Components.Autoplay.pause();
            splideProductsSupervise.Components.Autoplay.play();
    
            const slideIndex = newidx + 1;
            slider.productsSuperviseNumCurrentElm.innerHTML = slideIndex.toString().padStart(2, '0');
          });
    
          splideProductsSupervise.mount();
        }
    
        if (slider.newsNewElm != null) {
          const splideNewsNew = new Splide(slider.newsNewElm, slider.optionsNewsNew);
          splideNewsNew.mount();
        }
    
        if (slider.productsNewElm != null) {
          const splideProductsNew = new Splide(slider.productsNewElm, slider.optionsProductsNew);
          splideProductsNew.mount();
        }
    
        if (slider.productsExpertElm != null) {
          const splideProductsExpert = new Splide(slider.productsExpertElm, slider.optionsProductsExpert);
          splideProductsExpert.mount();
        }
    
        if (slider.lpLoopElm != null) {
          const splideLpLoop = new Splide(slider.lpLoopElm, slider.optionsLpLoop);
          splideLpLoop.mount(window.splide.Extensions);
        }
    
        if (slider.lpLoopMeritElm != null) {
          const splideLpLoopMerit = new Splide(slider.lpLoopMeritElm, slider.optionsLpLoopMerit);
          splideLpLoopMerit.mount(window.splide.Extensions);
        }
    
        const slideLpMeritNum = slider.lpMeritElm.length;
        for (let i = 0; i < slideLpMeritNum; i++) {
          const splideLpMerit = new Splide(slider.lpMeritElm[i], slider.optionsLpMerit);
          splideLpMerit.mount();
        }
    
        if (slider.commonBnrElm != null) {
          const splideBnr = new Splide(slider.commonBnrElm, slider.optionsBnr);
          splideBnr.mount();
        }
    
      },
    
    }
    
    

    
    const Animation = {
    
      init() {
        anime = {
          // add: 'js-animeAdd',
    
          loader: 'js-loader',
          time: (website.page == 'top') ? 2000 : 0,
    
          // word: 'js-animeWord',
        };
    
        // this.addAnime();
        // this.word();
      },
    
      check() {
        $('.' + website.targetAnime + ':not(.' + website.actAnime + ')').each(function () {
          let self = $(this),
            targetPosition = self.offset().top,
            triggerPosition,
            shift;
    
          if (website.winWidth < website.shiftPoint) {
            shift = website.winHeight / website.shiftSp;
          } else {
            shift = website.winHeight / website.shiftPc;
          }
          triggerPosition = targetPosition - website.winHeight + shift;
    
          if (website.scrollY > triggerPosition) {
            if (typeof self.data('delay') !== 'undefined') {
              self.css('transitionDelay', self.data('delay') + 'ms')
            }
            self.addClass(website.actAnime);
          }
        });
      },
    
      // addAnime() {
      //   let targets = Array.prototype.slice.call(document.querySelectorAll('.' + anime.add), 0);
      //   targets.forEach((target) => {
      //     if (target.dataset.anime) {
      //       target.style.animation = target.dataset.anime;
      //     }
      //   });
      // },
    
      loader() {
        if (website.page == 'top') {
          if (!Cookies.get('visited')) {
            document.getElementById(anime.loader).classList.add(website.act);
            Cookies.set('visited', 1);
          } else {
            anime.time = 0;
          }
    
          // setTimeout(function () {
          //   document.scrollingElement.scrollTop = 0;
          // }, 100);
        } else if (location.hash != "" && location.hash != "#") {
          // setTimeout(function () {
          //   let shift = (website.winWidth < website.shiftPoint) ? website.headTag.offsetHeight : 0,
          //     position = $(location.hash).offset().top - shift;
          //   $('body, html').animate({ scrollTop: position }, mod.smoothSpeed, 'swing');
          // }, 100);
        }
    
        if (website.page == 'top') {
          TopPage.init();
        }
    
        setTimeout(function () {
          document.body.classList.add(website.loaded);
          // PageScroll.observerAnime();
        }, anime.time);
      },
    
      // word() {
      //   let wordList = document.querySelectorAll('.' + anime.word),
      //     targetsWord = Array.prototype.slice.call(wordList, 0),
      //     delayHead = 0;
    
      //   targetsWord.forEach((target) => {
      //     let text = target.innerHTML,
      //       html = '',
      //       delay = 200;
    
      //     if (target.dataset.delay) {
      //       delay = target.dataset.delay - 0;
      //     }
    
      //     text.split(' ').forEach(function (w) {
      //       if (w == '<br>') {
      //         html += w;
      //         delay -= 100;
      //       } else if (w == '&nbsp;') {
      //         html += w;
      //       } else {
      //         html += '<span><span style="transition-delay: ' + delay + 'ms;">' + w + '</span></span>';
      //       }
      //       delay += 50;
      //     });
      //     target.innerHTML = html;
      //   });
      // },
    
    }
    
    

    
    const PageScroll = {
    
      init() {
        scrollOption = {
          target: document.getElementById('js-inertiaFrame'),
          translateY: 0,
          contHeight: 0,
          velocity: 0.08,
    
          animeTargets: document.querySelectorAll('.' + website.targetAnime + ':not(.' + website.actAnime + ')'),
          animeOptions: {
            rootMargin: "-15% 0px",
            threshold: 0,
          },
    
          navDisplayFrame: document.getElementById('js-navDisplay'),
          navDisplayTargets: document.querySelectorAll('.js-navDisplayObserver'),
          navDisplayOptions: {
            rootMargin: "-50% 0px",
            threshold: 0,
          },
    
          dataTargets: document.querySelectorAll('.js-dataObserver'),
          dataOptions: {
            rootMargin: "-50% 0px",
            threshold: 0,
          },
        };
    
        this.observerAnime();
        // this.observerNavDisplay();
        this.observerData();
      },
    
      set() {
        scrollOption.contHeight = scrollOption.target.getBoundingClientRect().height - 1;
        document.body.style.height = Math.floor(scrollOption.contHeight) + 'px';
      },
      smooth() {
        this.set();
    
        let diff = website.scrollY - scrollOption.translateY;
    
        if (diff !== 0) {
          if (Math.abs(diff) > 1) {
            scrollOption.translateY += diff * scrollOption.velocity;
          } else {
            scrollOption.translateY = website.scrollY;
          }
          scrollOption.target.style.transform = 'translate3d(0, -' + scrollOption.translateY + 'px, 0)';
        }
      },
    
      observerAnime() {
        let observer = new IntersectionObserver(this.observerCallbackAnime, scrollOption.animeOptions);
        scrollOption.animeTargets.forEach((target) => {
          if (target.dataset.delay) {
            target.style.transitionDelay = target.dataset.delay + 'ms';
          }
          observer.observe(target);
        });
      },
      observerCallbackAnime(entries, object) {
        entries.forEach(function (entry, i) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add(website.actAnime);
          object.unobserve(entry.target);
        });
      },
    
      observerNavDisplay() {
        let observer = new IntersectionObserver(this.observerCallbackNavDisplay, scrollOption.navDisplayOptions);
        scrollOption.navDisplayTargets.forEach((target) => {
          observer.observe(target);
        });
      },
      observerCallbackNavDisplay(entries, object) {
        entries.forEach(function (entry, i) {
          let data = entry.target.dataset.display;
          if (data !== '' && typeof data !== "undefined") {
            let displayClass = "is-" + data;
            if (entry.isIntersecting) {
              scrollOption.navDisplayFrame.classList.add(displayClass);
            } else {
              scrollOption.navDisplayFrame.classList.remove(displayClass);
            }
          }
        });
      },
    
      observerData() {
        let observer = new IntersectionObserver(this.observerCallbackData, scrollOption.dataOptions);
    
        scrollOption.dataTargets.forEach((target) => {
          observer.observe(target);
        });
      },
      observerCallbackData(entries, object) {
        entries.forEach(function (entry, i) {
          if (entry.target.parentNode.dataset.breakpoint && website.winWidth < website.breakpoint[entry.target.parentNode.dataset.breakpoint]) return;
    
          if (entry.isIntersecting) {
            let dataSplide = entry.target.parentNode.dataset.splide,
              dataSplideIndex = Number(entry.target.parentNode.dataset.index),
              dataIndex = Number(entry.target.dataset.index);
    
            if (
              (dataSplide !== '' && typeof dataSplide !== "undefined") &&
              (dataSplideIndex !== '' && typeof dataSplideIndex !== "undefined") &&
              (dataIndex !== '' && typeof dataIndex !== "undefined")
            ) {
              slider[dataSplide][dataSplideIndex].Components.Controller.go(dataIndex);
            }
          }
    
          let dataNav = entry.target.dataset.nav;
          if (typeof dataNav !== "undefined") {
            const elms = document.querySelectorAll('a[data-nav="' + dataNav + '"]');
            elms.forEach((target) => {
              if (entry.isIntersecting) {
                target.classList.add(website.act);
              } else {
                target.classList.remove(website.act);
              }
            });
          }
        });
      },
    }
    

    
    const Parallax = {
    
      init() {
        parallax = {
          nodeList: document.querySelectorAll('.js-parallax'),
          gap: 0.08,
    
          decoList: [],
        };
    
        let targets = Array.prototype.slice.call(parallax.nodeList, 0);
        targets.forEach((target) => {
          if (target.dataset.para) {
            let arr = target.dataset.para.split(',');
            parallax.decoList.push([target, arr]);
          }
        });
      },
    
      deviateScroll() {
        parallax.decoList.forEach((target) => {
          let targetRect = target[0].getBoundingClientRect(),
            diff = (website.winHeight / 2) - (target[0].offsetHeight / 2),
            gap = (target[1][2]) ? Number(target[1][2]) : parallax.gap,
            translateX,
            translateY;
    
          if ((targetRect.top - website.winHeight) <= 0) {
            if (target[1][0] == 'X') {
              translateX = (target[1][1] == 'reverse') ? -((targetRect.top - diff) * gap) : (targetRect.top - diff) * gap;
              target[0].style.transform = 'translate3d(' + translateX + 'px, 0px, 0px)';
            } else {
              translateY = (target[1][1] == 'reverse') ? -((targetRect.top - diff) * gap) : (targetRect.top - diff) * gap;
              target[0].style.transform = 'translate3d(0, ' + translateY + 'px, 0)';
            }
          }
        });
      },
    
    }
    
    




    const TopPage = {

      init() {
        top = {};

        SplideSlider.top();
      },

      update() {
      },

    }


    const BasicPage = {

      init() {
        basic = {
          // pageTopTag: document.getElementById('js-pageTop'),
          // megaMenuTarget: 'js-megaMenu',
          // megaMenuFadeOut: 400,

          fixedNavElm: document.getElementById('js-fixedNav'),
        };

        // this.pageTop();
        // this.scrollUpView();
        this.scrollUpNavSet();

        SplideSlider.other();
      },

      // pageTop() {
      //   if (basic.pageTopTag != null) {
      //     if (website.scrollY <= 100) {
      //       basic.pageTopTag.classList.remove(website.actView);
      //     } else {
      //       basic.pageTopTag.classList.add(website.actView);
      //     }
      //   }
      // },

      scrollUpView() {
        if (website.scrollY === website.scrollCurrent) {
          return;
        }

        if (website.scrollY <= 30 || website.scrollY < website.scrollCurrent) {
          website.headTag.classList.add(website.actView);
        } else {
          website.headTag.classList.remove(website.actView);
        }

        if (basic.fixedNavElm != null) {
          BasicPage.scrollUpNav();
        }

        website.scrollCurrent = website.scrollY;
      },

      scrollUpNavSet() {
        if (basic.fixedNavElm != null) {
          let cloneElm = basic.fixedNavElm.cloneNode(true);
          cloneElm.id = '';
          cloneElm.classList.remove(website.actFixed);
          basic.fixedNavElm.before(cloneElm);
        }
      },

      scrollUpNav() {
        if (website.scrollY === website.scrollCurrent) {
          return;
        }

        if (website.scrollY <= website.winHeight) {
          basic.fixedNavElm.classList.remove(website.actView);
        } else {
          if (website.scrollY < website.scrollCurrent) {
            basic.fixedNavElm.classList.add(website.actView);
          } else {
            basic.fixedNavElm.classList.remove(website.actView);
          }
        }
      },

      update() {
      },

    }


    const App = {

      init() {
        if (website.page != 'wp-manual' && website.page != 'wp-manual-single') {
          this.set();
          this.update();
        } else {
          // Modules.init();
          Wordpress.init();
        }
      },

      set() {
        Modules.init();
        Animation.init();
        PageScroll.init();
        Parallax.init();
        DrawerMenu.init();
        Wordpress.init();
        SplideSlider.init();
        BasicPage.init();


        if (website.page == 'top') {
          // TopPage.init();
        }


        WinLoad.add(Animation.loader);
        // WinLoad.add( Animation.check );
        // WinLoad.add( Modules.alignHeight );

        WinResize.add(Modules.iosCheck);
        WinResize.add(Modules.deviceCheck);

        WinResizeWidth.add(Modules.viewportHeight);
        WinResizeWidth.add(Modules.scrollbarWidth);
        // WinResizeWidth.add( Modules.alignHeight );

        // WinScroll.add( Animation.check );
        WinScroll.add(BasicPage.scrollUpView);

        // OrientationChange.add( xxx );


        WinLoad.init();
        WinResize.init();
        WinResizeWidth.init();
        WinScroll.init();
        OrientationChange.init();

      },

      update() {
        website.animationFrame = window.requestAnimationFrame(App.update);
        website.winWidth = window.innerWidth;
        website.winHeight = window.innerHeight;
        website.scrollY = window.pageYOffset;

        Parallax.deviateScroll();

        if (website.isDesktop) {
          // PageScroll.smooth();
        }
      },

    }


    App.init();

  })();


})(jQuery);
